// Application ase class for Stimulus controllers

import { Controller } from "@hotwired/stimulus"

export default class BaseController extends Controller {
  // generates stimulus HTML node
  // renderController('foo', {bar: baz, html: 123}, 'span')
  // -> <span data-controller="foo" bar="baz">123</span>
  static renderController(name, opts = {}, nodeName = 'div') {
    const html = opts.html || ''
    delete opts.html
    const attrs = Object.entries(opts).map(([key, value]) => `${key}="${value}"`).join(' ')
    return `
      <${nodeName} data-controller="${name}" ${attrs}>
        ${html}
      </${nodeName}>
    `
  }

  // instance methods

  getAttributes() {
    const attributes = this.element.attributes;
    const result = {};

    for (let i = 0; i < attributes.length; i++) {
      result[attributes[i].name] = attributes[i].value;
    }

    delete result['data-controller']

    return result;
  }

  // get attribute by name
  attr(name) {
    return this.element.getAttribute(name)
  }

  qs(name) {
    const params = new URLSearchParams(window.location.search)
    return params.get(name)
  }

  // escape text
  htmlEscape(text) {
    if (typeof text === 'string') {
      return text
        .replaceAll("'", '&apos;')
        .replaceAll('"', '&quot;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
    } else {
      return text
    }
  }
}

